/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * Creates an product card offers box instance
 *
 * @module enervee_utils.product_card
 */
function productCardOffersBoxDirective() {
    return {
        restrict: 'E',
        scope: {
            product: '=',
        },
        controller: productCardOffersBoxController,
        template: require('./offersBoxView.html')
    };
}

productCardOffersBoxController.$inject = [
    '$scope',
    'CmsContentService',
    'ProductService',
    'UtilitySelectorCookieService',
    'UtilService'
];
function productCardOffersBoxController(
    $scope,
    CmsContentService,
    ProductService,
    UtilitySelectorCookieService,
    UtilService
) {
    $scope.hasSponsoredOffers = false;
    $scope.quantity = 3;

    $scope.$watch('product.best_online_offers', function () {
        if ($scope.product.active_offers) {
            $scope.hasSponsoredOffers = $scope.product.best_online_offers.filter(function (offer) {
                return offer.sponsored;
            });
        }
        if ($scope.product.best_online_offers !== undefined) {
            $scope.product.best_online_offers.forEach(function (offer, count) {
                offer.imageId = "Offer" + count;
            });

            var bestOnlineOffersCount = $scope.product.best_online_offers.length;

            if (bestOnlineOffersCount === 1) {
                CmsContentService.getMarketPlaceText(
                    'product_card:offers_count_singular',
                    {
                        'store_name': $scope.product.best_online_offers[0].store_name
                    },
                    $scope.product.category.id
                ).then(function (text) {
                    $scope.seeBestOffers = text;
                });
            } else if (bestOnlineOffersCount === 0) {
                $scope.seeBestOffers = '0 offers available';
            } else {
                CmsContentService.getMarketPlaceText(
                    'product_card:offers_count_pluralized',
                    {
                        'offers_count': bestOnlineOffersCount
                    },
                    $scope.product.category.id
                ).then(function (text) {
                    $scope.seeBestOffers = text;
                });
            }
        }
    });

    $scope.redirectToRetailer = function (offer, index) {
        if ($scope.product.category.category_code === 'cars') {
            // for cars, we need to add the zipcode to the link

            // TODO: this lives in StoreLocatorService, which can't be moved to common yet. Remove this once that
            // TODO: service is moved.
            var zipcode = UtilitySelectorCookieService.getUserZipCode();
            if (!zipcode){
                zipcode = UtilService.getSiteSetting('location_settings', {zipcode: '90291'}).zipcode;
            }
            if (zipcode){
                offer.link = UtilService.addQueryParamToURL(link, 'zipcode=' + zipcode);
            }
        }
        ProductService.redirectToRetailer($scope.product, offer, index);
    };
}

module.exports = productCardOffersBoxDirective;
